import { FC } from 'react';
import { AdvertChunkDataByServiceType } from '@edikk-edikk/country-frontend';
import catalogByServiceItemCss from '#srcCssModules/advert/catalog/catalog-by-service-item.module.scss';
import { LoadMore } from '#advertList/components/catalog-by-service/LoadMore';
import { AdvertCardList } from '#advert/components/card-list';

type PropsType = {
  chunk: AdvertChunkDataByServiceType;
};

const CatalogByServiceItem: FC<PropsType> = ({
  chunk,
}) => (
  <div className={catalogByServiceItemCss.catalogByServiceItem}>
    <h3 className={catalogByServiceItemCss.catalogByServiceItem__title}>
      {chunk.title}
    </h3>
    <AdvertCardList
      adverts={chunk.adverts}
      total={chunk.pagination.totalCount}
    />
    <LoadMore
      pagination={chunk.pagination}
      serviceId={chunk.serviceId}
    />
  </div>
);

export { CatalogByServiceItem };
